import axios from "axios";
import caseStudiesData from "@/data/caseStudies.json";
import testimonialsData from "@/data/testimonials.json";
import { LEADS } from "@/config/site.config";
import { basePath } from "@/lib/assets";

/**
 * Lead submission.
 *
 * Delivery is handled by the PHP mailer at `public/api/contact.php`, which sends over
 * SMTP using the credentials in `public/api/config.php` (server-side, never committed).
 * Endpoint and origin are configured in `src/config/site.config.js`.
 *
 * In local development only (LEADS.localFallback), a failed request is written to
 * localStorage and reported as success, since there is usually no PHP runtime. Recover
 * queued leads from the browser console with:
 *   JSON.parse(localStorage.getItem("snapx_leads"))
 * In production the error is thrown, and the form tells the visitor how to reach us.
 */
const endpointUrl = () => {
  const path = LEADS.endpoint.startsWith("/") ? LEADS.endpoint : `/${LEADS.endpoint}`;
  return LEADS.origin ? `${LEADS.origin}${path}` : `${basePath()}${path}`;
};

export const submitLead = async (payload) => {
  try {
    const res = await axios.post(endpointUrl(), payload, {
      headers: { "Content-Type": "application/json" },
      timeout: 10000,
    });
    return res.data;
  } catch (err) {
    if (!LEADS.localFallback) throw err;
    console.warn("Lead endpoint unreachable — queuing this lead in localStorage.", err?.message);
    const existing = JSON.parse(localStorage.getItem("snapx_leads") || "[]");
    existing.unshift({ ...payload, id: `local_${Date.now()}`, created_at: new Date().toISOString() });
    localStorage.setItem("snapx_leads", JSON.stringify(existing));
    return { ok: true, local: true };
  }
};

/** Case studies and testimonials ship with the bundle — no network round-trip needed. */
export const fetchTestimonials = async () => testimonialsData;

export const fetchCaseStudies = async () => caseStudiesData;

export const fetchCaseStudy = async (slug) => {
  const found = caseStudiesData.find((s) => s.slug === slug);
  if (!found) throw new Error("Case study not found");
  return found;
};
